export default __webpack_public_path__ + "static/photo-bar-1-f01a846d10daa107fd0877be01b1f04a.jpg";